import { useUserContext, useVerbiageQuery } from "@repo/baseCloud";
import { Birdhouse, Edit, Link, LayoutDashboard, Logs } from "lucide-react";

import { useSettingsApi } from "./api/settingsApi";
import { useLocationContext } from "./contexts/editableItemContext";
import { usePendingChangesContext } from "./contexts/pendingChangesContext";

/** Constant, so PortalLayout's effect on `states` runs once instead of on every render */
export const layoutStates = [
	{
		id: "all",
		label: "All",
		color: "bg-purple-500",
		lightColor: "bg-purple-50",
		textColor: "text-purple-500",
		hoverColor: "hover:bg-purple-50",
		activeColor: "bg-purple-100",
		activeTextColor: "text-purple-700",
		borderColor: "border-purple-500",
	},
];

export function usePages() {
	const { locationId, location } = useLocationContext();
	const { useSettingsQuery } = useSettingsApi();
	const { data: settings } = useSettingsQuery();
	const { user } = useUserContext();
	const { userIsVendorAdmin, userIsVendorUser } = user;
	const userIsVendorNonAdmin = userIsVendorUser && !userIsVendorAdmin;
	const { fieldAudit } = useVerbiageQuery().verbiage;
	const { isItemChanged } = usePendingChangesContext();

	const edit = {
		id: "edit",
		label: "Edit",
		icon: Edit,
		changes: isItemChanged("location"),
		count: 0,
		hidden: !user?.userIsAdmin,
		disabled: false,
	};

	const statusHistory = {
		id: "statusHistory",
		label: "Status History",
		icon: Logs,
		changes: isItemChanged("statusHistory"),
		count: 0,
		hidden: !user?.userIsAdmin,
		disabled: !locationId,
	};

	const associations = {
		id: "associations",
		label: "Associations",
		icon: Link,
		changes: isItemChanged("associationsInfo"),
		count: 0,
		hidden: userIsVendorNonAdmin,
		disabled: !locationId || (userIsVendorAdmin && !location?.marketerName) || userIsVendorNonAdmin,
	};

	const summary = {
		id: "summary",
		label: "Summary",
		icon: LayoutDashboard,
		changes: false,
		count: 0,
		hidden: false,
		disabled: !locationId,
	};

	const fieldAudits = {
		id: "fieldAudits",
		label: fieldAudit,
		icon: Birdhouse,
		changes: isItemChanged("repFieldAudit"),
		count: 0,
		hidden: !settings?.tabs?.fieldAudit,
		disabled: !locationId,
	};

	return {
		all: [summary, edit, statusHistory, associations, fieldAudits],
	};
}
